<script>
import ServicesMixin from '@components/services/mixin';
import Comment from '@components/services/Comment.vue';

export default {
  name: "CommentsDialog",
  props: {
    txnID: Number
  },
  mixins: [ServicesMixin],
  components: { Comment },
  data() {
    return {
      visible: false,
      text: ''
    }
  },
  computed: {
    comments() {
      return this.$store.state.comments;
    }
  },
  methods: {
    open() {
      this.visible = true;
      this.getComments(this.txnID);
    },
    send() {
      this.postComment(this.txnID, this.text);
      this.text = '';
    }
  }
}
</script>

<template>
  <Button icon="pi pi-comment"
          @click="open"
          text rounded aria-label="Show"/>
  <Dialog v-model:visible="visible" modal :header="`Comments for Transaction #${txnID}`" :style="{ height: '35rem' }">
    <div class="d-flex flex-column h-100">
      <div class="flex-grow-1 overflow-auto">
        <Comment v-for="c in comments" :comment-obj="c" :key="c.id"/>
        <p v-if="comments.length === 0">No comments on this transaction.</p>
      </div>
      <div class="mt-auto">
        <FancyTextArea v-model="text" rows="3" cols="30" class="w-full mb-2" />
        <div class="d-flex justify-content-end">
          <Button icon="pi pi-send" @click="send" label="Send" text rounded aria-label="Send"/>
        </div>
      </div>
    </div>
  </Dialog>
</template>

<style scoped>

</style>